import {useState, useContext} from 'react';
import {AxiosContext} from '../components/utils/AxiosProvider';

const usePostForm = endpoint => {
    const [submissionInProgress, setSubmissionInProgress] = useState(null);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient} = useContext(AxiosContext);

    const onFormPosted = result => {
        setResult(result.data);
        setSubmissionInProgress(false);
        error && setError(null);
        return result.data;
    };

    const onError = error => {
        setSubmissionInProgress(false);
        result && setResult(null);
        setError(error.response?.data);
    };

    const post = formData => {
        setSubmissionInProgress(true);
        return axiosClient
            .post('/api/1/user/' + endpoint, formData)
            .then(onFormPosted)
            .catch(onError);
    };

    return {
        post,
        submissionInProgress,
        result,
        error,
    };
};

export default usePostForm;

const usePostError = () => {
    return usePostForm('feedback');
};

const errorDataHelper = data => {
    const augmentedData = {
        feedback_text: `[AUTO GENERATED][GENERIC]`,
        frontend_state: {
            ...JSON.parse(localStorage.getItem('__STATE_MACHINE__')),
            _ui_state: {
                href: window?.location?.href,
            },
        },
        ...data,
    };
    return augmentedData;
};

export {usePostError, errorDataHelper};
